import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp, SectionTag } from "@/components/motion";

const FAQS = [
  {
    q: "Does getting welded hurt?",
    a: "Not at all. The welding spark never touches your skin — we place a protective barrier between the chain and you. Most guests describe it as a tiny flash of light and nothing more.",
  },
  {
    q: "Can I go through airport security with it?",
    a: "Yes. Fine jewelry doesn't set off metal detectors, so your bracelet or anklet travels everywhere you do — no removal needed at TSA.",
  },
  {
    q: "What if I need to remove it?",
    a: "Simply snip the chain at the small welded ring with scissors. Keep the chain safe and we can re-weld it for you whenever you're ready.",
  },
  {
    q: "What metals do you offer?",
    a: "We work with gold filled and 925 sterling silver chains in a range of styles and thicknesses, plus charms and connectors to make yours one of a kind.",
  },
  {
    q: "How do party bookings work?",
    a: "You pick the occasion — bridal shower, birthday, girls' night, corporate event — and we bring the full studio to your venue. Each guest gets a private fitting and weld. Send us your date and group size and we'll plan it together.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 sm:py-28 lg:py-36">
      <div className="px-4 sm:px-8 lg:px-16 max-w-3xl mx-auto">
        <FadeUp className="text-center mb-12">
          <SectionTag>Questions</SectionTag>
          <h2 className="mt-3 font-serif tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Before you're <span className="italic text-gold">linked.</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-ink/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-lg sm:text-xl text-ink hover:text-gold hover:no-underline transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-stone-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
